/// <amd-module name="Build/Admin/Common/Client/Contracts/DistributedTask/Wrappers" />
import { CheckIssue } from "Checks/Client/Contracts/PipelinesChecks";
import { TaskAgentPool, TaskAgentQueue } from "DistributedTask/Client/Contracts/TaskAgent";

export interface TaskAgentQueueWrapper extends TaskAgentQueue{
    issue?: CheckIssue
}

export interface TaskAgentPoolWrapper extends TaskAgentPool{
    issue?: CheckIssue
}